const CONTINUE_INPUT_TYPES: readonly string[] = [
  "text",
  "email",
  "tel",
  "search",
  "number",
];

/** Whether a key press means "Continue": Enter in a text input, outside
 * an IME composition. `inputType` is the focused input's type, or null
 * when the focus is not on an input. */
export function isContinueKey(press: {
  key: string;
  composing: boolean;
  inputType: string | null;
}): boolean {
  return (
    press.key === "Enter" &&
    !press.composing &&
    press.inputType !== null &&
    CONTINUE_INPUT_TYPES.includes(press.inputType)
  );
}
